export default __webpack_public_path__ + "static/media/Shop.6700b162.JPG";